import axios from '@/utilities/axios-global'

export function PATCH_CODER_CONTACTID(context, payload) {
  return new Promise((resolve, reject) => {
    let url
    if (payload.contactId) {
      url = context.rootState.user.baseApiUrl + `/client-coders/${payload.coderId}/update-contactid?contactId=${payload.contactId}`
    } else {
      // don't send the contactId query param in to clear the contact id from the coder
      url = context.rootState.user.baseApiUrl + `/client-coders/${payload.coderId}/update-contactid`
    }
    axios.patch(url).then((response) => {
      resolve(response.data)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export default {
  PATCH_CODER_CONTACTID
}
